// src/components/StatusChipRow.js
import * as React from "react";
import { Chip, Stack } from "@mui/material";

export const DEFAULT_STATUS_CONFIG = [
    { status: "PENDING", label: "En attente", color: "warning" },
    { status: "VALIDATED", label: "Validés", color: "success" },
    { status: "REJECTED", label: "Rejetés", color: "error" },
];

export default function StatusChipRow({
    counts = {},
    total = 0,
    config = DEFAULT_STATUS_CONFIG,
    showTotal = false,
    totalLabel = "Total",
    totalColor = "primary",
    sx,
    ...stackProps
}) {
    if (!config.length && !showTotal) {
        return null;
    }

    return (
        <Stack
            direction="row"
            spacing={1}
            sx={{ flexWrap: "wrap", ...(sx || {}) }}
            {...stackProps}
        >
            {showTotal && (
                <Chip
                    size="small"
                    variant="outlined"
                    color={totalColor}
                    label={`${totalLabel} ${total}`}
                />
            )}
            {config.map(({ status, label, color = "default", ...rest }) => (
                <Chip
                    key={status}
                    size="small"
                    variant="outlined"
                    color={color}
                    label={`${label} ${counts[status] ?? 0}`}
                    {...rest}
                />
            ))}
        </Stack>
    );
}
